export default () => ({
  setVideoSource(desktopURL, mobileURL) {
    const video = this.$refs.video;
    const screenWidth = window.innerWidth;
    const isMobile = screenWidth <= 1023;

    const deviceSource = isMobile ? mobileURL : desktopURL;
    const sourceElement = video.querySelector("source");

    sourceElement.setAttribute("data-src", deviceSource);
    sourceElement.src = deviceSource;

    video.load();
  },
});
